import { parseAlgoliaHitSnippet } from '@algolia/autocomplete-preset-algolia';
import { createElement, Fragment } from 'react';

type SnippetHitParams<THit> = {
  /**
   * The Algolia hit whose attribute to retrieve the highlighted parts from.
   */
  hit: THit;
  /**
   * The attribute to retrieve the highlighted parts from.
   *
   * You can use the array syntax to reference nested attributes.
   */
  attribute: keyof THit | string[];
  /**
   * The tag name to use for highlighted parts.
   *
   * @default "mark"
   */
  tag?: string | React.FunctionComponent;
};

export function Snippet<THit>({
  hit,
  attribute,
  tag = 'mark',
}: SnippetHitParams<THit>): JSX.Element {
  return createElement(
    Fragment,
    {},
    parseAlgoliaHitSnippet<THit>({ hit, attribute }).map(
      ({ value, isHighlighted }, index) => {
        if (isHighlighted) {
          return createElement(tag, { key: index }, value);
        }

        return value;
      }
    )
  );
}

